import { styled } from "@mui/material/styles";
import { Box, Button } from "@mui/material";
import React from "react";

interface ButtonTypeProps {
  isSelected: boolean;
  onClick?: () => void;
  title: string;
  isMovile: boolean;
  width: string;
  widthMoviles: string;
  height: string;
  heightMoviles: string;
  icon: string;
  width_icon: string;
  height_icon: string;
  font_size_movil?: string;
  font_size?: string;
  top_icon?: string;
}

const StyledButtonWrapper = styled(Box)({
  position: "relative",
  display: "inline-block",
});

// 👇️ props filtradas del DOM usando shouldForwardProp
const StyledPersonButton = styled(Button, {
  shouldForwardProp: (prop) =>
    ![
      "selected",
      "isMovile",
      "width",
      "widthMoviles",
      "height",
      "heightMoviles",
      "font_size_movil",
      "font_size",
    ].includes(prop as string),
})<{
  selected: boolean;
  isMovile: boolean;
  width: string;
  widthMoviles: string;
  height: string;
  heightMoviles: string;
  font_size: string;
  font_size_movil: string;
}>(({ selected, isMovile, width, widthMoviles, height, heightMoviles, theme, font_size_movil, font_size }) => ({
  position: "relative",
  zIndex: 1,
  width: isMovile ? widthMoviles : width,
  height: isMovile ? heightMoviles : height,
  borderRadius: "5px",
  backgroundColor: selected ? theme.palette.primary.dark : theme.palette.primary.main,
  color: "#FFFFFF",
  border: selected ? `2px solid ${theme.palette.primary.accent}` : "none",
  boxShadow: selected ? "2px 4px 10px rgba(200, 150, 150, 0.4)" : "none",
  textTransform: "none",
  fontSize: isMovile ? font_size_movil : font_size,
  fontWeight: 400,
  "&:hover": {
    backgroundColor: theme.palette.primary.dark,
    color: "#FFFFFF",
  },
}));

const CheckImage = styled("img", {
  shouldForwardProp: (prop) => prop !== "top_icon",
})<{
  top_icon?: string;
}>(({ top_icon }) => ({
  position: "absolute",
  top: top_icon || "-16px",
  left: "calc(50% - 12px)",
  borderRadius: "50%",
  padding: "0px",
  zIndex: 2,
}));

export const ButtonTypeSelected: React.FC<ButtonTypeProps> = ({
  isSelected,
  onClick,
  title,
  isMovile,
  height,
  heightMoviles,
  width,
  widthMoviles,
  icon,
  width_icon,
  height_icon,
  font_size = "14px",
  font_size_movil = "11px",
  top_icon,
}) => {
  return (
    <StyledButtonWrapper>
      {isSelected && (
        <CheckImage src={icon} alt="Seleccionado" width={width_icon} height={height_icon} top_icon={top_icon} />
      )}
      <StyledPersonButton
        selected={isSelected}
        onClick={onClick}
        isMovile={isMovile}
        height={height}
        heightMoviles={heightMoviles}
        width={width}
        widthMoviles={widthMoviles}
        font_size={font_size}
        font_size_movil={font_size_movil}
      >
        {title}
      </StyledPersonButton>
    </StyledButtonWrapper>
  );
};
